'use client';

import { useTranslation } from '@whoop/i18n/lang/client';
import React, { useState } from 'react';
import { UnstyledButton } from 'ui';
import Image from 'next/image';
import { PerksList } from 'ui/components/PerksList/PerksList';
import LoadingButton from 'ui/components/ButtonV2/LoadingButton';
import LearnMoreModal from '@/components/LearnMoreModal/LearnMoreModal';
import { GOOSE_TRIAL_IMAGE } from '@/lib/constants/images';
import SectionHeader from '@/components/SectionHeader/SectionHeader';
import { GOOSE_TRIAL_PERKS } from '@/lib/constants/maverick';
interface ChooseTrialSectionProps {
  isAddingToCart: boolean;
  onCTAClick: () => Promise<void>;
  renewalPrice: number;
}
export default function ChooseTrialSection({
  isAddingToCart,
  onCTAClick,
  renewalPrice
}: ChooseTrialSectionProps) {
  const {
    t
  } = useTranslation('membershipTiers');
  const [isLearnMoreModalOpen, setIsLearnMoreModalOpen] = useState(false);
  const translatedPerks = GOOSE_TRIAL_PERKS.map(perk => ({
    key: t(perk.key),
    iconStyle: perk.iconStyle
  }));
  return <>
      <LearnMoreModal disabled={isAddingToCart} handleChooseTrial={onCTAClick} isOpen={isLearnMoreModalOpen} renewalPrice={renewalPrice} setIsOpen={setIsLearnMoreModalOpen} data-sentry-element="LearnMoreModal" data-sentry-source-file="ChooseTrialSection.tsx" />
      <div className='flex w-full items-center justify-center bg-white px-6 py-14 text-black' data-testid='choose-trial-section'>
        <div className='desktop:grid desktop:grid-cols-2 flex w-full max-w-screen-lg flex-col items-center justify-center gap-5 rounded-xl p-6'>
          <div className='desktop:order-2 order-1 flex w-full justify-center'>
            <div className='flex w-full max-w-96 flex-col items-center gap-5 text-center'>
              <SectionHeader data-sentry-element="SectionHeader" data-sentry-source-file="ChooseTrialSection.tsx">
                {t(`membershipTiers:chooseTrial:title`)}
              </SectionHeader>

              <div className='flex w-full flex-col gap-5 text-base'>
                <p>{t(`membershipTiers:chooseTrial:description`)}</p>
              </div>
            </div>
          </div>
          <div className='desktop:order-1 order-2 row-span-2 flex w-full items-center justify-center'>
            <Image alt={t(`membershipTiers:chooseTrial:title`)} className='aspect-square w-full max-w-[456px]' height={426} src={GOOSE_TRIAL_IMAGE} width={456} data-sentry-element="Image" data-sentry-source-file="ChooseTrialSection.tsx" />
          </div>
          <div className='order-3 flex w-full justify-center'>
            <div className='desktop:text-left flex w-full max-w-96 flex-col gap-5'>
              <PerksList className='w-full' perks={translatedPerks} data-sentry-element="PerksList" data-sentry-source-file="ChooseTrialSection.tsx" />
              <LoadingButton disabled={isAddingToCart} onClick={onCTAClick} size='medium' variant='secondary' data-sentry-element="LoadingButton" data-sentry-source-file="ChooseTrialSection.tsx">
                {t('tryForFree')}
              </LoadingButton>
              <UnstyledButton className='text-sm font-semibold uppercase tracking-wide' onClick={() => setIsLearnMoreModalOpen(true)} data-sentry-element="UnstyledButton" data-sentry-source-file="ChooseTrialSection.tsx">
                {t('learnMore')}
              </UnstyledButton>
            </div>
          </div>
        </div>
      </div>
    </>;
}